import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SubMenu from "./SubMenu";
import useWindowWidth from "../../hooks/useWindowWidth";

function MenuList({ menus, ...props }) {
  const windowWidth = useWindowWidth();
  const handleLinkClick = (path) => {
    if (path === "/buysell") {
      localStorage.removeItem("holding");
    }
  };

  return (
    <div className="navWrapper p-4">
      {(!props.isCollapsed || windowWidth < 768) &&
        <ul id="menu">
          {menus?.map((menu, index) =>
            menu.submenu ? (
              <SubMenu key={menu.label} menu={menu} props={props} />
            ) : menu.path ? (
              <li
                key={menu.label}
                className={``}
                onClick={props.toggle}
                title={menu.label}
              >
                <NavLink
                  to={`${menu.path}`}
                  className="link menuLink"
                  onClick={() => handleLinkClick(menu.path)}
                >
                  {index === 2 ? (
                    <img
                      src={menu.icon}
                      style={{ height: "22px", marginLeft: "2px" }}
                    />
                  ) : !menu.iconCustom ? (
                    <FontAwesomeIcon
                      icon={menu.icon}
                      className="w-6"
                    ></FontAwesomeIcon>
                  ) : (
                    menu.iconCustom
                  )}

                  {!props.isCollapsed && (
                    <span>
                      {menu.label}
                    </span>
                  )}
                  {windowWidth < 768 && props.isCollapsed && (
                    <span className={`${index === 2 && "ml-1"}`}>
                      {menu.label}
                    </span>
                  )}
                </NavLink>
              </li>
            ) : (
              <li key={menu.label} className="mt-5 mb-3">
                <span
                  className={"text-gray-500 font-medium uppercase text-xs mx-2"}
                >
                  {menu.label} {menu.role}
                </span>
              </li>
            )
          )}
        </ul>
      }
    </div>
  );
}

export default MenuList;
